<!-- TO BE DEPRECATED AFTER BLOCK-WEB-GLOBAL-NAV LAUNCH -->
<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import { quadIn, quadOut } from 'svelte/easing';
  import { ResponsiveVars } from '@twist/core';
  import { cx } from '@emotion/css';

  import Navbar from '$components/Navigation/Navbar.svelte';
  import NavLink from '$components/Navigation/NavLink.svelte';
  import { duration, delay } from '$components/Transitions/PageTransitionStore';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import { anchorNavigationStore } from '$lib/stores/anchorNavigation';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import afterimage from '../../svelteDirectives/AfterImage';

  export let border = false;
  export let fixed = true;

  let navbarEl: HTMLDivElement;

  const brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  function updateAnchorNavigationOffset() {
    anchorNavigationStore.setOffset(navbarEl.offsetHeight + navbarEl.offsetTop);
  }

  onMount(() => {
    updateAnchorNavigationOffset();
  });

  onDestroy(() => {
    anchorNavigationStore.setOffset(0);
  });

  const responsiveVars = new ResponsiveVars()
    .addFluid('nav-position-mt', toFluidVarInput(24, 32))
    .addFluid('nav-mx', toFluidVarInput(24, 72))
    .toCSS();
</script>

<svelte:window on:resize={updateAnchorNavigationOffset} />

<div
  bind:this={navbarEl}
  class:fixed
  class={cx(responsiveVars, 'nav-position')}
  in:afterimage={{ amount: 20, opacity: 0, duration: $duration, delay: $delay, easing: quadIn }}
  out:afterimage={{ amount: 20, opacity: 0, duration: $duration, easing: quadOut }}
>
  <div class="nav" class:border>
    <Navbar>
      {#if brandReskinEnabled}
        <BlockButton href="/news">News</BlockButton>

        <BlockButton href="/careers/jobs">Careers</BlockButton>

        <BlockButton href="https://investors.block.xyz/overview/default.aspx" target="_blank">
          Investors
        </BlockButton>
      {:else}
        <NavLink href="/news" label="News" />

        <NavLink href="/careers/jobs" label="Careers" />

        <NavLink
          href="https://investors.block.xyz/overview/default.aspx"
          label="Investors"
          isExternal
        />
      {/if}
    </Navbar>
  </div>
</div>

<style lang="scss">
  @import 'src/scss/variables';
  @import 'src/scss/media';

  .nav-position {
    top: 0;
    pointer-events: none;
    position: absolute;
    z-index: map-get($zIndex, primary-nav);
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: var(--nav-position-mt);

    &.fixed {
      position: fixed;
    }
  }

  .nav {
    width: 100%;
    pointer-events: all;
    margin: 0px var(--nav-mx);

    &.border {
      border: 1px solid white;
      border-radius: 1000px;
    }

    @include at('lg') {
      width: auto;
    }
  }
</style>
